import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { useGroupUrl } from '@/hooks/use-group-url';

export const UnitRouteWrapper: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const {
    data: unit,
    isFetching: isFetchingUnit,
    isUninitialized: isUnitUninitialized,
  } = useCurrentUnit();
  const isLoadingUnit = isUnitUninitialized || isFetchingUnit;
  const groupUrl = useGroupUrl();

  const unitId = unit?.id ?? -1;

  useEffect(() => {
    if (!isLoadingUnit && unitId < 0) {
      navigate(groupUrl);
    }
  }, [isLoadingUnit, groupUrl, unitId, navigate]);

  return (
    <>
      {unitId < 0 ? (
        <div className="flex h-full flex-col items-center justify-center">
          <BeatLoader />
        </div>
      ) : (
        children
      )}
    </>
  );
};
